module.exports = __webpack_public_path__ + "static/media/view.edf57554.svg";